import { httpClient } from '@configs/httpclient.config';
import { AxiosResponse } from 'axios';
import { GroupsTypesRoot } from './types';

const URL = '/moex-propack-integrationservice/api/curves/v1/groups-and-type-assets_list';

export const getAssetGroupsAndTypes = (): Promise<AxiosResponse<GroupsTypesRoot>> => {
    return httpClient.get(URL);
};
